import { Box, Typography, Grid } from "@mui/material";
import { useEffect, useState } from "react";

// Later. Sa BE manggagaling to
const tarpaulins: {
  img: string;
  end_date: string;
  isVisible?: boolean; // FE ONLY
  timeRemaining?: {
    // FE ONLY
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  };
}[] = [
  {
    img: "/assets/images/banner-countdown-sklbkl.png",
    end_date: "2025-06-12T23:59:00+08:00",
  },
];

function getRemainingTime(targetDate?: Date) {
  if (!targetDate) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
  const now = new Date();
  const diff = targetDate.getTime() - now.getTime();

  const days = Math.max(Math.floor(diff / (1000 * 60 * 60 * 24)), 0);
  const hours = Math.max(Math.floor((diff / (1000 * 60 * 60)) % 24), 0);
  const minutes = Math.max(Math.floor((diff / (1000 * 60)) % 60), 0);
  const seconds = Math.max(Math.floor((diff / 1000) % 60), 0);

  return { days, hours, minutes, seconds };
}

export default function TarpaulinCountdown() {
  const [tarpaulinsWithCountdown, setTarpaulinsWithCountdown] =
    useState(tarpaulins);

  useEffect(() => {
    const timer = setInterval(() => {
      setTarpaulinsWithCountdown((prevTarpaulins) =>
        prevTarpaulins.map((tarpaulin) => {
          const targetDate = new Date(tarpaulin.end_date);
          const remainingTime = getRemainingTime(targetDate);
          return {
            ...tarpaulin,
            timeRemaining: remainingTime,
            isVisible:
              remainingTime.days > 0 ||
              remainingTime.hours > 0 ||
              remainingTime.minutes > 0 ||
              remainingTime.seconds > 0,
          };
        })
      );
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div>
      {tarpaulinsWithCountdown?.map((tarpaulin, index) => {
        const remainingTime = getRemainingTime(
          tarpaulin.end_date ? new Date(tarpaulin.end_date) : undefined
        );

        if (!tarpaulin?.isVisible) {
          return null; // Skip rendering if the tarpaulin is not visible
        }

        return (
          <Box
            key={index}
            sx={{
              width: "100%",
              height: { xs: 140, md: 200 },
              position: "relative",
              backgroundImage: `url(${tarpaulin.img})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderRadius: 2,
              my: 1,
              px: 2,
              py: 3,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              alignItems="center"
              flexWrap="wrap"
              sx={{ marginTop: { xs: 7, md: 9 } }}
            >
              <TimerBlock label="Days" value={remainingTime.days} />
              <Colon />
              <TimerBlock label="Hours" value={remainingTime.hours} />
              <Colon />
              <TimerBlock label="Minutes" value={remainingTime.minutes} />
              <Colon />
              <TimerBlock label="Seconds" value={remainingTime.seconds} />
            </Grid>
          </Box>
        );
      })}
    </div>
  );
}

function TimerBlock({ label, value }: { label: string; value: number }) {
  const digits = String(value).padStart(2, "0").split("");

  return (
    <Grid item xs={1.9} sm={1.4} md={1.25} lg={1.3}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box display="flex" gap={1}>
          {digits.map((digit, index) => (
            <Box
              key={index}
              sx={{
                backgroundColor: "white",
                borderRadius: 1,
                color: "#0C304A",
                minWidth: 30,
                px: { md: 2, sm: 1 },
                py: 0.5,
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: {
                    lg: "46px",
                    xs: "26px",
                  },
                }}
                fontFamily={"'Times New Roman'"}
              >
                {digit}
              </Typography>
            </Box>
          ))}
        </Box>
        <Typography
          sx={{
            fontSize: {
              xs: "0.8em",
              sm: "1em",
            },
          }}
          mt={0.5}
          // color={"white"}
        >
          {label}
        </Typography>
      </Box>
    </Grid>
  );
}

function Colon() {
  return (
    <Grid item>
      <Typography
        variant="h3"
        fontWeight="bold"
        sx={{ color: "white", mx: 1, mb: 4 }}
      >
        :
      </Typography>
    </Grid>
  );
}
